import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {withRouter} from 'react-router-dom';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

// Material UI
import { withStyles } from 'material-ui/styles';

// Authentication
import { auth } from '../../../../../../config/constants/database';

// Styles
import styles from './styles';

// Actions
import { LoginInProgress } from './actions';

class Submit extends Component {

  constructor(props){
    super(props);

    this.state = {

    };
    this.handleLocalLogin = this.handleLocalLogin.bind(this);
  }

  handleLocalLogin = () => {
    if (this.props.password.length == 0 || this.props.email.length == 0) {
      alert("You must fill in both your username and password in order to sign in.");
    } else {
      this.props.LoginInProgress(true);
      auth().signInWithEmailAndPassword(this.props.email, this.props.password).catch(function(error) {
        if (error) {
          alert(error.message);
          window.location.reload();
        } else {
          alert("You are now signed in.")
        }
      });
    }
  }

  render(){
    const { classes, location} = this.props;

    if (this.props.login_in_progress) {
      return(
        <div className={classes.root}>
          <Typography className={classes.root} type="title" color="black" gutterBottom align="center">
            LOGGING YOU IN...
          </Typography>
        </div>
      );
    } else {
      return(
        <div className={classes.root}>
          <Button raised color="primary" onClick={() => this.handleLocalLogin()} align="center" className={classes.button}>Sign-In</Button>
        </div>
      );
    }
  }
}

Submit.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        email: state.email.email,
        password: state.password.password,
        login_in_progress: state.loginInProgress.login_in_progress,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
      LoginInProgress: LoginInProgress,
    }, dispatch);
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(Submit)));



// WEBPACK FOOTER //
// ./src/scenes/Login/components/CoreContent/components/Submit/index.js